import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@projeccions-pdc/react-icon';
import Share from './Share';
import Favorites from './Favorites';
import Etc from './Etc';
import { isAdmin, isEditor } from '../../../helpers';
import queryString from 'query-string';
import OfflineTip from '../OfflineTip';
import { isDeviceOnline, isSmartphone } from '../../../helpers';
import { /*ToolsData,*/ ToolsDataPerPlatformId } from '../../../ToolsList';
import LocalizedStrings from '../../Localization/localization';
import NotificationsBadge from '../NotificationsBadge';
import TutorialViewer from '../../Tutorials/TutorialViewer';
import './Menu.css';
import AppContext from '../../../AppContext';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchOpen: false,
            platformId: new AppContext().getPlatformId(),
        };

        this.onSearchChange = this.onSearchChange.bind(this);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    async componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
        await this.refreshOnline();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.currentContent &&
            prevProps.currentContent &&
            this.props.currentContent.contentId !== prevProps.currentContent.contentId
        ) {
            this.refreshOnline();
        }
    }

    refreshOnline = async () => {
        let isOnline = await isDeviceOnline();
        this.setState({ isOnline });
    };

    componentWillUnmount() {
        clearInterval(this.refreshInterval);
    }

    onSearchChange(isOpen) {
        this.setState({ searchOpen: isOpen });
    }

    goToCharly = (evt) => {
        let lastIsHome = false;
        const parsed = queryString.parse(this.context.router.route.location.search);
        lastIsHome = parsed.mtg !== undefined ? true : false;
        if (this.state.platformId === 'brandhub') {
            this.goToRoute(evt, '/');
            // console.log(parsed);
        } else {
            if (lastIsHome) {
                // this.context.router.history.push('/home#meet');
                this.goToRoute(evt, '/home#meet');
            } else {
                // this.context.router.history.push('/home');
                this.goToRoute(evt, '/home');
            }
        }
    };

    goToRoute = (evt, uri) => {
        if (evt && (evt.ctrlKey || evt.metaKey)) {
            window.open(uri, '_blank');
        } else {
            this.context.router.history.push(uri);
        }
    };

    render() {
        let numItems;
        if (this.props.isInside) {
            numItems = 2;
        } else {
            numItems = 2;
        }
        let px = 45 * numItems;
        if (this.state.searchOpen) {
            px = px - 45 + 200;
        }
        const style = { marginRight: px + 'px' };

        let isAdminVar = isAdmin();
        let isEditorVar = isEditor();

        let currentTool = 'inside';

        return (
            <div className="fe-top-bar">
                <div className="fe-navigation-menu-button" onClick={this.goToCharly}>
                    <NotificationsBadge>
                        <Icon name="fa-th" />
                    </NotificationsBadge>
                </div>
                {!this.props.isInside ? (
                    <div className="fe-top-bar-left" style={style}>
                        {ToolsDataPerPlatformId(this.state.platformId).map((route) => {
                            if (route.etc === true) {
                                return '';
                            }

                            if (isAdminVar === false && route.role === 'admin') {
                                return '';
                            }

                            if (isAdminVar === false && isEditorVar === false && route.role === 'adminoreditor') {
                                return '';
                            }

                            if (route.etcSmartphone && this.state.smartphoneView) {
                                return '';
                            }

                            let isActive = false;
                            if (this.context.router.route.match.url.indexOf(route.uri) !== -1) {
                                isActive = true;
                                currentTool = route.title;
                            }
                            if (route.title === 'editor') {
                                if (this.context.router.route.match.url.indexOf('/metadocument/edit') !== -1) {
                                    isActive = true;
                                    currentTool = route.title;
                                }
                            }
                            return (
                                <div
                                    key={route.title}
                                    className="fe-menu-button fe-menu-backend-button"
                                    onClick={(evt) => this.goToRoute(evt, route.uri)}
                                >
                                    <div style={{ display: 'inline-block' }}>
                                        {this.state.smartphoneView !== true ? (
                                            LocalizedStrings[route.title]
                                        ) : (
                                            <Icon name={route.iconElement} />
                                        )}
                                    </div>
                                    {isActive === true ? <div className="fe-menu-backend-button-selected" /> : ''}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    ''
                )}
                <div className="fe-top-bar-right">
                    <TutorialViewer tutorialContextId={currentTool}>
                        <div className={'fe-menu-button'} data-id="tutorialViewer">
                            <Icon name="md-help-outline" size={'20px'} />
                        </div>
                    </TutorialViewer>
                    {this.state.isOnline !== true && (
                        <OfflineTip style={{ display: 'inline-block' }}>
                            <div className={'fe-menu-button'}>
                                <Icon name="md-flash-off" size={'20px'} />
                            </div>
                        </OfflineTip>
                    )}
                    {this.state.isOnline === true && this.props.isInside === true && (
                        <Favorites currentContent={this.props.currentContent} />
                    )}
                    {this.props.isInside && this.state.isOnline === true && (
                        <Share currentContent={this.props.currentContent} notify={this.props.notify} />
                    )}
                    <Etc
                        isInside={this.props.isInside}
                        notify={this.props.notify}
                        isOnline={this.state.isOnline}
                        smartphoneView={this.state.smartphoneView}
                    />
                </div>
            </div>
        );
    }
}
Menu.propTypes = {
    isInside: PropTypes.bool.isRequired,
    currentContent: PropTypes.object,
    notify: PropTypes.func.isRequired,
};
Menu.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};

export default Menu;
